"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

var _httpResult = _interopRequireDefault(require("./http-result"));

var _uploadError = _interopRequireDefault(require("./upload-error"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Retrieves a list of all file results that were successful.
 *
 * @param {Array} fileResults List of FileUploadResult instance to analyze.
 * @returns {Array} Contains only those FileUploadResult instance from fileResults that were successful.
 */
function getSuccessfulFileResults(fileResults) {
  var success = [];
  fileResults.forEach(function (result) {
    if (result.isSuccessful()) {
      success.push(result);
    }
  });
  return success;
}
/**
 * Represents results for the upload process as a whole, which might include multiple files. Results
 * include information such as total upload time, total file size, total number of files, etc.
 */


var UploadResult = /*#__PURE__*/function (_HttpResult) {
  _inherits(UploadResult, _HttpResult);

  var _super = _createSuper(UploadResult);

  /**
   * Constructs a new instance of the results, which can be used to add more information.
   *
   * @param {object} options Options as provided when the upload instance was instantiated.
   * @param {DirectBinaryUploadOptions} uploadOptions Options as provided when the upload was initiated.
   */
  function UploadResult(options, uploadOptions) {
    var _this;

    _classCallCheck(this, UploadResult);

    _this = _super.call(this, options, uploadOptions);
    _this.initTime = 0;
    _this.totalTime = 0;
    _this.totalFiles = 0;
    _this.fileUploadResults = [];
    _this.errors = [];
    return _this;
  }
  /**
   * Starts a timer that will be used to calculate the total amount of time it takes for the upload
   * process to complete.
   */


  _createClass(UploadResult, [{
    key: "startTimer",
    value: function startTimer() {
      this.start = new Date().getTime();
    }
    /**
     * Stops the timer and calculates the amount of time elapsed since startTimer() was called.
     */

  }, {
    key: "stopTimer",
    value: function stopTimer() {
      if (this.start) {
        this.totalTime += new Date().getTime() - this.start;
      }
    }
    /**
     * Adds new individual file results to the overall result. Will be used to calculate various overall metrics.
     *
     * @param {FileUploadResult} fileUploadResult Result whose metrics will be included in the overall result.
     */

  }, {
    key: "addFileUploadResult",
    value: function addFileUploadResult(fileUploadResult) {
      this.fileUploadResults.push(fileUploadResult);
    }
    /**
     * Adds an amount of time, in milliseconds, to the result's total time it's taken for initiate upload requests
     * to complete.
     *
     * @param {number} elapsedTime Time span in milliseconds.
     */

  }, {
    key: "addInitTime",
    value: function addInitTime(elapsedTime) {
      this.initTime += elapsedTime;
    }
    /**
     * Retrieves the amount of time, in milliseconds, that it took the direct binary upload initiate request
     * to complete.
     *
     * @returns {number} Time span in milliseconds.
     */

  }, {
    key: "getInitTime",
    value: function getInitTime() {
      return this.initTime;
    }
    /**
     * Sets the total number of files that are initially included in the overall upload.
     *
     * @param {number} totalFiles Number of files.
     */

  }, {
    key: "addTotalFiles",
    value: function addTotalFiles(totalFiles) {
      this.totalFiles += totalFiles;
    }
    /**
     * Retrieves the total number of files initially included in the overall upload.
     *
     * @returns {number} Number of files.
     */

  }, {
    key: "getTotalFiles",
    value: function getTotalFiles() {
      return this.totalFiles;
    }
    /**
     * Retrieves the number of files that uploaded successfully.
     *
     * @returns {number} Number of files.
     */

  }, {
    key: "getTotalCompletedFiles",
    value: function getTotalCompletedFiles() {
      return getSuccessfulFileResults(this.fileUploadResults).length;
    }
    /**
     * Retrieves the total amount of time, in milliseconds, that elapsed between calls to startTimer() and stopTimer().
     *
     * @returns {number} Time span in milliseconds.
     */

  }, {
    key: "getElapsedTime",
    value: function getElapsedTime() {
      return this.totalTime;
    }
    /**
     * Sets the total amount of time, in milliseconds, that it took for the upload to complete.
     *
     * @param {number} totalTime Time span in milliseconds.
     */

  }, {
    key: "setElapsedTime",
    value: function setElapsedTime(totalTime) {
      this.totalTime = totalTime;
    }
    /**
     * Retrieves the total size, in bytes, of all files initially provided to the upload process.
     *
     * @returns {number} Size in bytes.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var size = 0;
      this.fileUploadResults.forEach(function (result) {
        size += result.getFileSize();
      });
      return size;
    }
    /**
     * Retrieves the average size, in bytes, of all files initially provided to the upload process.
     *
     * @returns {number} Size in bytes.
     */

  }, {
    key: "getAverageFileSize",
    value: function getAverageFileSize() {
      return (0, _utils.getAverage)(this.fileUploadResults.map(function (result) {
        return result.getFileSize();
      }));
    }
    /**
     * Retrieves the average amount of time, in milliseconds, it took for all files that were
     * uploaded successfully to fully transfer.
     *
     * @returns {number} Time span in milliseconds.
     */

  }, {
    key: "getAverageFileUploadTime",
    value: function getAverageFileUploadTime() {
      return (0, _utils.getAverage)(getSuccessfulFileResults(this.fileUploadResults).map(function (result) {
        return result.getTotalUploadTime();
      }));
    }
    /**
     * Retrieves the average amount of time, in milliseconds, it took for individual file parts
     * to fully transfer.
     *
     * @returns {number} Time span in milliseconds.
     */

  }, {
    key: "getAveragePartUploadTime",
    value: function getAveragePartUploadTime() {
      return (0, _utils.getAverage)(getSuccessfulFileResults(this.fileUploadResults).map(function (result) {
        return result.getAveragePartUploadTime();
      }));
    }
    /**
     * Retrieves the average amount of time, in milliseconds, it took for the direct binary
     * access complete request to finish.
     *
     * @returns {number} Time span in milliseconds.
     */

  }, {
    key: "getAverageCompleteTime",
    value: function getAverageCompleteTime() {
      return (0, _utils.getAverage)(getSuccessfulFileResults(this.fileUploadResults).map(function (result) {
        return result.getTotalCompleteTime();
      }));
    }
    /**
     * Retrieves the total time to upload that was in the 90th percentile for the upload process.
     *
     * @returns {number} Time span in milliseconds.
     */

  }, {
    key: "getNinetyPercentileTotal",
    value: function getNinetyPercentileTotal() {
      var totalSpentArr = getSuccessfulFileResults(this.fileUploadResults).map(function (result) {
        return result.getTotalUploadTime() + result.getTotalCompleteTime();
      });

      if (totalSpentArr.length > 0) {
        var sortedTotalSpentArr = totalSpentArr.sort(function (x, y) {
          return x - y;
        });
        var nintyPercentileIndex = Math.round(this.getTotalCompletedFiles() * 0.9) - 1;
        return sortedTotalSpentArr[nintyPercentileIndex];
      }

      return 0;
    }
    /**
     * Retrieves all the individual file upload results contained in the overall result.
     *
     * @returns {Array} List of FileUploadResult instances.
     */

  }, {
    key: "getFileUploadResults",
    value: function getFileUploadResults() {
      return this.fileUploadResults;
    }
    /**
     * Retrieves all the errors that occurred in the transfer process.
     *
     * @returns {Array} List of UploadError instances.
     */

  }, {
    key: "getErrors",
    value: function getErrors() {
      var errors = _toConsumableArray(this.getUploadErrors());

      this.getFileUploadResults().forEach(function (result) {
        result.getErrors().forEach(function (error) {
          errors.push(error);
        });
      });
      return errors;
    }
    /**
     * Adds a high-level error that prevented the upload from completing.
     *
     * @param {*} e An error object.
     */

  }, {
    key: "addUploadError",
    value: function addUploadError(e) {
      this.errors.push(_uploadError.default.fromError(e));
    }
    /**
     * Retrieves a list of high-level errors that prevented the upload from
     * completing.
     *
     * @returns {Array} An array of error objects.
     */

  }, {
    key: "getUploadErrors",
    value: function getUploadErrors() {
      return this.errors;
    }
    /**
     * Converts the result instance into a simple object containing all result data.
     *
     * @returns {object} Result data in a simple format.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return _objectSpread({
        host: this.getUploadOptions().getUrlPrefix(),
        initSpent: this.getInitTime(),
        totalFiles: this.getTotalFiles(),
        totalTime: this.getElapsedTime(),
        totalCompleted: this.getTotalCompletedFiles(),
        finalSpent: this.getElapsedTime(),
        totalFileSize: this.getTotalSize(),
        avgFileSize: this.getAverageFileSize(),
        avgPutSpent: this.getAveragePartUploadTime(),
        avgCompleteSpent: this.getAverageCompleteTime(),
        nintyPercentileTotal: this.getNinetyPercentileTotal(),
        detailedResult: this.fileUploadResults.map(function (result) {
          return result.toJSON();
        }),
        errors: this.errors
      }, _get(_getPrototypeOf(UploadResult.prototype), "toJSON", this).call(this));
    }
  }]);

  return UploadResult;
}(_httpResult.default);

exports.default = UploadResult;